export const addOrRemoveFromArray = <T>(array: T[], el: T) => {
  if (array.includes(el)) {
    return array.filter(prev => prev !== el);
  }

  return [...array, el];
};
